import { render } from "./Tenant_Invoices.vue?vue&type=template&id=3744c472&scoped=true"
import script from "./Tenant_Invoices.vue?vue&type=script&lang=js"
export * from "./Tenant_Invoices.vue?vue&type=script&lang=js"

import "./Tenant_Invoices.vue?vue&type=style&index=0&id=3744c472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3744c472"]])

export default __exports__